module.exports = __webpack_public_path__ + "static/media/mikro@2x.66096a7c.png";